// @flow

import type { DeviceType, ProductItem } from '@chatchamp/chatchamp-types'

export const CHATBOT_EVENTS = {
  Loaded: 'ChatchampChatbotLoaded',
  Started: 'ChatchampChatbotStarted',
  Restarted: 'ChatchampChatbotRestarted',
  UrlButtonClicked: 'ChatchampChatbotUrlButtonClicked',
  WelcomeMessageClick: 'ChatchampChatbotWelcomeMessageClick',
  WelcomeMessageClosed: 'ChatchampChatbotWelcomeMessageClosed',
  OpenChatClick: 'ChatchampChatbotOpenChatClick',
  CloseChatClick: 'ChatchampChatbotCloseChatClick',
  RecommendedProductClicked: 'ChatchampChatbotRecommendedProductClicked',
  AddedToCart: 'ChatchampChatbotAddedToCart',
  RoutineAddedToCart: 'ChatchampChatbotRoutineAddedToCart',
  AttributeMatchingListExpanded: 'ChatchampChatbotAttributeMatchingListExpanded',
  RecommendedProductInfoClicked: 'ChatchampChatbotRecommendedProductInfoClicked',
  MoreProductsLoaded: 'ChatchampChatbotMoreProductsLoaded',
  AttributeSet: 'ChatchampChatbotAttributeSet',
  Completed: 'ChatchampChatbotCompleted'
}

export type StartedEventPayload = {
  customerId: string,
  subscriberId: string,
  chatbotId: number,
  trigger?: string,
  parentUrl: string
}

export type RestartedEventPayload = {
  customerId: string,
  subscriberId: string,
  chatbotId: number,
  parentUrl: string
}

export type WelcomeMessageClickEventPayload = {
  customerId: string,
  subscriberId: string,
  welcomeMessageId?: number,
  device: DeviceType,
  welcomeMessageBubbleClick?: boolean
}

export type OpenChatClickEventPayload = {
  customerId: string,
  subscriberId: string,
  welcomeMessageId?: number,
  device: DeviceType
}

export type CloseChatClickEventPayload = {
  customerId: string,
  subscriberId: string,
  device: DeviceType
}

export type RecommendedProductClickedEventPayload = {
  customerId: string,
  subscriberId: string,
  chatbotId: number,
  productId: string,
  productIdentifier: string,
  parentUrl: string,
  utility: number
}

export type AddedToCartEventPayload = RecommendedProductClickedEventPayload

export type RoutineAddedToCartEventPayload = {
  customerId: string,
  subscriberId: string,
  chatbotId: number,
  productIds: string,
  parentUrl: string
}

export type AttributeMatchingListExpandedEventPayload = RecommendedProductClickedEventPayload

export type RecommendedProductInfoClickedEventPayload = RecommendedProductClickedEventPayload

export type MoreProductsLoadedEventPayload = RoutineAddedToCartEventPayload & {
  products: Array<ProductItem>
}

export type ChatchampChatbotCompleted = MoreProductsLoadedEventPayload
